export default {
    countCells: 10,
    massive: [
        {
            dataField: 'actions',
            cols: 1,
            rows: 1,
            text: '',
            class: 'd-flex flex-row align-center justify-center ',
            styles: 'flex-basis: 50px',
            order: 0,
            variable: true,
        },
        {
            dataField: 'npg',
            cols: 4,
            rows: 1,
            class: 'justify-start d-flex flex-row',
            styles: 'min-width: 350px',
            text: `НПС (код и наименование)`,
            order: 6,
            variable: true,
            template: (row) => {
                return row.sprKcpGroupId + ' - ' + row.sprKcpGroupName
            }
        },
        {
            dataField: 'glsnm',
            cols: 2,
            rows: 1,
            text: `Регистрационный номер`,
            order: 7,
            variable: true,
            rules: [
                v => !!v || 'введите значение',
            ],
            styles: 'justify-content: unset; text-align: center; text-align: center;',
        },
        {
            dataField: 'gldtb',
            cols: 2,
            rows: 1,
            text: `Дата выдачи`,
            order: 9,
            variable: true,

            typeValue: 'date',
            styles: 'justify-content: unset; text-align: center;',
        },
        {
            dataField: 'gltxt',
            cols: 1,
            rows: 1,
            text: `Комментарии`,
            order: 10,
            variable: true,
            class: 'd-flex  justify-center',
            styles: 'justify-content: unset; text-align: center;',
        },
    ]
}
export const headersForDialog = [
    {
        "text": "НПС",
        "dataField": "idSprSpec",
        "typeVar": "selector",
        "variableName": 'idSprSpec',
        "sprDataName": 'sprSpec',
        "rules": 3,
        "order": 0,
    },
    {
        "text": "Регистрационный номер",
        "dataField": "glsnm",
        "typeVar": "string",
        "rules": 'customRules',
        "customsRulesArray": [
            v => !!v || 'введите значение',
        ],
        "order": 1,
    },
    {
        "text": "Дата выдачи лицензии",
        "dataField": "gldtb",
        "typeVar": "date",
        "rules": 3,
        "order": 2,
    },
    {
        "text": "Комментарии",
        "dataField": "gltxt",
        "typeVar": "textarea",
        "rules": 0,
        "order": 4,
    },
]

